<template>
  <div class="mysearch">
    <div class="search">
      <div class="search-box">
        <div class="item">
          <slot name="search"></slot>
        </div>
        <!-- <div class="pull">下拉</div> -->
      </div>
      <!-- <div class="btn">
        <slot name="btn"></slot> 
      </div> -->
    </div>
  </div>
</template>

<script>
  export default {
  }
</script>

<style scoped>
  .mysearch {
    width: 100%;
    margin-bottom: 20px;
  }
  .mysearch .search {
    width: 100%;
    display: flex;
  }
  .mysearch .search .search-box {
    position: relative;
    flex: 1;
  }
  .mysearch .search .item {
    width: 100%;
    display: flex;
    flex-direction: row;
    /* min-height: 60px; */
    /* height: 60px; */
    flex-wrap: wrap;
  }
  .mysearch .pull {
    /* position: absolute; */
    /* left: 0;
    bottom: -20px; */
    width: 100%;
    height: 20px;
    cursor: pointer;
    text-align: center;
    margin-bottom: 8px;
  }
</style>


// WEBPACK FOOTER //
// src/Util/Search.vue